import { Component, Inject } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import Env from '@ridango/core/env';

@Component({
    selector: 'gl-schedule-favourites-page',
    templateUrl: './schedule-favourites-page.component.html',
    styleUrls: ['./schedule-favourites-page.component.scss']
})
export class ScheduleFavouritesPageComponent {
    constructor(@Inject('ENV') public env: Env, public translate: TranslateService) {}
}
